import { clamp } from "./Time";
import { Input } from "./Input";
import type { Scene } from "./types";

export class Engine {
  private ctx: CanvasRenderingContext2D;
  private input: Input;
  private unmountInput?: () => void;

  private running = false;
  private lastTs = 0;

  constructor(private canvas: HTMLCanvasElement) {
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("Canvas 2D non supporté");
    this.ctx = ctx;
    this.input = new Input(canvas);
  }

  getContext() {
    return this.ctx;
  }

  getInput() {
    return this.input;
  }

  mountInput() {
    this.unmountInput = this.input.mount();
  }

  unmountInputListeners() {
    this.unmountInput?.();
    this.unmountInput = undefined;
  }

  resizeToDisplay() {
    const rect = this.canvas.getBoundingClientRect();
    const dpr = window.devicePixelRatio || 1;
    const w = Math.max(1, Math.floor(rect.width * dpr));
    const h = Math.max(1, Math.floor(rect.height * dpr));
    if (this.canvas.width !== w || this.canvas.height !== h) {
      this.canvas.width = w;
      this.canvas.height = h;
    }
  }

  start(loop: (dt: number) => void) {
    if (this.running) return;
    this.running = true;
    this.lastTs = performance.now();

    const tick = (ts: number) => {
      if (!this.running) return;
      const rawDt = (ts - this.lastTs) / 1000;
      this.lastTs = ts;

      // clamp dt pour éviter les sauts (tab inactive, lag)
      const dt = clamp(rawDt, 0, 1 / 15);

      this.resizeToDisplay();
      loop(dt);

      requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  }

  stop() {
    this.running = false;
  }
}
